<template>
<div class="tgh-gallery tgh-page">
  <TitlePage title="GALLERY CATALOGUE" desc=" "></TitlePage>
  <div class="tgh-gallery-box" v-if="galleryList.length > 0">
    <div class="row no-gutters">
      <router-link :to="`/gallery-catalogue/${encodeURI(gallery.id)}`" v-for="(gallery,galleryIndex) in galleryList" :key="`gallery-item-${galleryIndex}`" :class="`col-12 ${colheight} col-md-${colSize}`" :style="(gallery.photo_available) ? `background-image:url('${gallery.photo}');` : '-webkit-filter: grayscale(0);filter: grayscale(0);background-position:center center;background-size:cover'">
        <div>
          <h1>{{ gallery.title }}</h1>
        </div>
      </router-link>
    </div>
  </div>
  <div class="tgh-blank" v-if="galleryList.length < 1"></div>
  <AddressNav></AddressNav>
</div>
</template>

<script>
import {
  apiUrl
} from '../config'
import axios from 'axios'
import AddressNav from '@/components/AddressNav.vue'
import TitlePage from '@/components/TitlePage.vue'
export default {
  name: 'Gallery',
  components: {
    AddressNav,
    TitlePage
  },
  data() {
    return {
      galleryList: [],
      colSize: 6,
      colheight: '',
      summary: []
    }
  },
  methods: {
    getData() {
      let vm = this
      let url = apiUrl + '/gallery?sort=id&page=1&per_page=100'
      axios.get(
          url
        )
        .then(response => {
          if (response.data.status) {
            vm.galleryList = response.data.data
            switch (vm.galleryList.length) {
              case 1:
                vm.colSize = 12
                vm.colheight = 'height-full'
                break;
              case 2:
                vm.colSize = 6
                vm.colheight = 'height-full'
                break;
              case 3:
                vm.colSize = 4
                vm.colheight = 'height-full'
                break;
              case 4:
                vm.colSize = 6
                break;
            }
          }
        })
        .catch(e => {
          console.log('Internal server error')
        })
    },
    getSummary() {
      let vm = this
      let url = apiUrl + '/home/summary'
      axios.get(
          url
        )
        .then(response => {
          if (response.data.status) {
            vm.summary = response.data.data.gallery
          }
        })
        .catch(e => {
          console.log('Internal server error')
        })
    }
  },
  mounted() {
    this.getData()
    this.getSummary()
  }
}
</script>
